/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('comment');
const COMMENT_LIST = "COMMENT_LIST";
const COMMENT_EDIT = "COMMENT_EDIT";
const COMMENT_ADD = "COMMENT_ADD";
const COMMENT_DELETE = "COMMENT_DELETE";
const COMMENT_SENSIVE = "COMMENT_SENSIVE";
const COMMENT_MAKE_TOP = "COMMENT_MAKE_TOP";
const COMMENT_CANCEL_TOP = "COMMENT_CANCEL_TOP";

export default {
    COMMENT_LIST,
    commentList : (search)=>{
        search && (search.page = search.current || 1);//保持antd的风格
        search.sort = '-createtime';

        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>{
              console.log(data);
              return ({
                  type:COMMENT_LIST,
                  data
              });
            }
        })
    },
    COMMENT_ADD,
    commentAdd:(data)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data,
            success:(data)=>({
                type:COMMENT_ADD,
                data
            })
        })
    },
    COMMENT_EDIT,
    commentEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:COMMENT_EDIT,
                data,
            })
        })
    },
    COMMENT_SENSIVE,
    commentSensive:(word)=>{
        return ajaxCommon({
            api:TheApi('post')('sensive'),
            data:{
                word
            },
            success:(data)=>({
                type:COMMENT_SENSIVE,
                data
            })
        })
    },
    COMMENT_DELETE,
    commentDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:COMMENT_DELETE,
                id,
                data
            })
        })
    },
    COMMENT_MAKE_TOP,
    commentMakeTop:(id)=>
        ajaxCommon({
            api:TheApi('post')('maketop'),
            data: {
                id,
            },
            success:()=>({
                type: COMMENT_MAKE_TOP,
            })
        }),
    COMMENT_CANCEL_TOP,
    commentCancelTop:(id)=>
        ajaxCommon({
            api:TheApi('post')('canceltop'),
            data: {
                id,
            },
            success:()=>({
                type: COMMENT_MAKE_TOP,
            })
        }),
}



// WEBPACK FOOTER //
// ./src/actions/CommentAction.js